import Emitter from "es6-event-emitter";

import template from "./../templates/readingModeButtonComponent.dust";
import { createDivWithClass } from "../../../common/utilities/utils";
import i18n from "../../../common/dictionary";

import {
  CLICKED_TOP_NAV_SINGLE_PAGE_MODE,
  CLICKED_TOP_NAV_DOUBLE_PAGE_MODE,
} from "../../../common/analytics/analyticsevents";
//TODOD: move to web this is not a shared component
export default class ReadingModeButtonComponent extends Emitter {
  constructor(appState, pubStore, options) {
    super();
    this._appState = appState;
    this._options = options;
    this._pubStore = pubStore;
    this.DOMContainer = document.querySelector(
      ".top-bar-container .top-bar-access"
    );
    this._appState.on(
      "appState:isDoublePageChanged",
      this.toggleSinglePageMode
    );
  }

  render() {
    const context = {
      i18n,
      isDoublePage: this._appState.isDoublePage,
      useCustomToolTip: this._options ? this._options.useCustomTooltips : false,
      displayTopNavButtonlabel: this._options
        ? this._options.displayTopNavButtonlabel
        : false,
    };
    if (this.DOMContainer) {
      Dust.render(template, context, this._renderDone.bind(this));
    }
  }

  //////////////

  _renderDone(err, result) {
    this.toggleSinglePageMode();
    const div = createDivWithClass("reading-mode-button-component");
    if (this._options && this._options.displayTopNavButtonlabel) {
      div.classList.add("labelDisplayed");
    }
    div.innerHTML = result;
    this.DOMContainer.appendChild(div);
    this._toggleIcon();
    this._attachEventListeners();
  }

  _attachEventListeners() {
    this._readingMode = this.DOMContainer.querySelector(
      ".reading-mode-button-component"
    );
    if (this._readingMode) {
      this._readingMode.addEventListener("click", (e) => {
        this._onClickHandler(e);
      });
    }
    this._pubStore.on("pubStore:pubLoaded", this._toggleIcon);
  }

  _onClickHandler(e) {
    this._appState.isDoublePage = !this._appState.isDoublePage;
    if (e.target.classList.contains("single-page-mode")) {
      this._appState.triggerEvent(CLICKED_TOP_NAV_SINGLE_PAGE_MODE);
    } else {
      this._appState.triggerEvent(CLICKED_TOP_NAV_DOUBLE_PAGE_MODE);
    }
    this._appState.trigger("readerReadingMode:clicked");
    this.toggleSinglePageMode();
    this.updateIconandlabel();
  }

  toggleSinglePageMode = () => {
    this.updateIconandlabel();
    if (
      this._appState.isDoublePage ||
      !this._pubStore.isCurrentPublicationReplica()
    ) {
      if (document.body.classList.contains("singlePage"))
        document.body.classList.remove("singlePage");
    } else {
      if (!document.body.classList.contains("singlePage"))
        document.body.classList.add("singlePage");
    }
  };

  updateIconandlabel() {
    const doublePageBtn = document.querySelector(".double-page-mode");
    const doublePageLbl = document.querySelector(".double-page-mode-label");

    const singlePageBtn = document.querySelector(".single-page-mode");
    const singlePageLbl = document.querySelector(".single-page-mode-label");

    if (this._appState.isDoublePage) {
      if (doublePageBtn && doublePageBtn.classList.contains("active")) {
        doublePageBtn.classList.remove("active");
      }

      if (doublePageLbl && doublePageLbl.classList.contains("active")) {
        doublePageLbl.classList.remove("active");
      }

      if (singlePageBtn && !singlePageBtn.classList.contains("active")) {
        singlePageBtn.classList.add("active");
      }
      if (singlePageLbl && !singlePageLbl.classList.contains("active")) {
        singlePageLbl.classList.add("active");
      }
    } else {
      if (doublePageBtn && !doublePageBtn.classList.contains("active")) {
        doublePageBtn.classList.add("active");
      }
      if (doublePageLbl && !doublePageLbl.classList.contains("active")) {
        doublePageLbl.classList.add("active");
      }

      if (singlePageBtn && singlePageBtn.classList.contains("active")) {
        singlePageBtn.classList.remove("active");
      }
      if (singlePageLbl && singlePageLbl.classList.contains("active")) {
        singlePageLbl.classList.remove("active");
      }
    }
  }

  _toggleIcon = () => {
    const readingModeButton = document.querySelector(
      ".reading-mode-button-component"
    );
    if (this._pubStore.isCurrentPublicationReplica()) {
      readingModeButton.classList.remove("hidden");
    } else {
      readingModeButton.classList.add("hidden");
    }
  };

  _destroy() {
    this._pubStore.on("pubStore:pubLoaded", this._toggleIcon);
    this._readingMode.removeEventListener("click", (e) => {
      this._onClickHandler(e);
    });
  }
}



// WEBPACK FOOTER //
// ./src/web/reader/components/readingModeButtonComponent.js